var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5049 7.11741C32.8191 5.68304 30.7119 5 28.6046 5C26.0057 5 23.3365 6.09286 21.3697 8.00536L20.0351 9.43973L18.6303 8.00536C16.6635 6.09286 13.9943 5 11.3954 5C9.28815 5 7.1809 5.68304 5.4951 7.11741C1.06987 10.8058 0.859146 17.3629 4.79268 21.3246L18.4196 34.9853C18.841 35.3951 19.4029 35.6 19.9649 35.6C20.5971 35.6 21.159 35.3951 21.5804 34.9853L35.2073 21.3246C39.1409 17.3629 38.9301 10.8058 34.5049 7.11741ZM32.7489 19.0705L20.0351 31.8433L7.25114 19.0705C5.0034 16.7482 4.44147 12.3085 7.67259 9.64464C10.4823 7.25402 14.3455 8.41518 16.1718 10.3277L20.0351 14.1527L23.8282 10.3277C25.6545 8.48348 29.5177 7.25402 32.3274 9.64464C35.5585 12.3085 35.0668 16.7482 32.7489 19.0705Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ca23effcb3b35549aaf4be77d4db2c3c.svg";
export { ForwardRef as ReactComponent };